// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/common/v1/consensus.proto (package thru.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/common/v1/consensus.proto.
 */
export const file_thru_common_v1_consensus: GenFile = /*@__PURE__*/
  fileDesc("Ch50aHJ1L2NvbW1vbi92MS9jb25zZW5zdXMucHJvdG8SDnRocnUuY29tbW9uLnYxIooECg5WZXJzaW9uQ29udGV4dBI2CgdjdXJyZW50GAEgASgLMh4udGhydS5jb21tb24udjEuQ3VycmVudFZlcnNpb25CA+BBAUgAEk4KE2N1cnJlbnRPckhpc3RvcmljYWwYAiABKAsyKi50aHJ1LmNvbW1vbi52MS5DdXJyZW50T3JIaXN0b3JpY2FsVmVyc2lvbkID4EEBSAASEwoEc2xvdBgDIAEoBEID4EEBSAASNAoJdGltZXN0YW1wGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEID4EEBSAASMAoIc2xvdF9zZXEYBSABKAsyFy50aHJ1LmNvbW1vbi52MS5TbG90U2VxQgPgQQFIADrnAbpI4wEa4AEKHHZlcnNpb25fY29udGV4dF9oYXNfc2VsZWN0b3ISTW9uZSBvZiBjdXJyZW50LCBjdXJyZW50T3JIaXN0b3JpY2FsLCBzbG90LCB0aW1lc3RhbXAsIG9yIHNsb3Rfc2VxIG11c3QgYmUgc2V0GnFoYXModGhpcy5jdXJyZW50KSB8fCBoYXModGhpcy5jdXJyZW50T3JIaXN0b3JpY2FsKSB8fCBoYXModGhpcy5zbG90KSB8fCBoYXModGhpcy50aW1lc3RhbXApIHx8IGhhcyh0aGlzLnNsb3Rfc2VxKUIJCgd2ZXJzaW9uIhAKDkN1cnJlbnRWZXJzaW9uIhwKGkN1cnJlbnRPckhpc3RvcmljYWxWZXJzaW9uIi4KB1Nsb3RTZXESEQoEc2xvdBgBIAEoBEID4EECEhAKA3NlcRgCIAEoBEID4EECKt8BCg9Db25zZW5zdXNTdGF0dXMSIAocQ09OU0VOU1VTX1NUQVRVU19VTlNQRUNJRklFRBAAEh0KGUNPTlNFTlNVU19TVEFUVVNfT0JTRVJWRUQQARIdChlDT05TRU5TVVNfU1RBVFVTX0lOQ0xVREVEEAISHgoaQ09OU0VOU1VTX1NUQVRVU19GSU5BTElaRUQQAxIlCiFDT05TRU5TVVNfU1RBVFVTX0xPQ0FMTFlfRVhFQ1VURUQQBBIlCiFDT05TRU5TVVNfU1RBVFVTX0NMVVNURVJfRVhFQ1VURUQQBULKAQoSY29tLnRocnUuY29tbW9uLnYxQg5Db25zZW5zdXNQcm90b1ABWkRnaXRodWIuY29tL1VudG8tTGFicy90aHJ1LW5ldC9ncnBjL3BrZy9wcm90by90aHJ1L2NvbW1vbi92MTtjb21tb252MaICA1RDWKoCDlRocnUuQ29tbW9uLlYxugIDVEhVygIOVGhydVxDb21tb25cVjHiAhpUaHJ1XENvbW1vblxWMVxHUEJNZXRhZGF0YeoCEFRocnU6OkNvbW1vbjo6VjFiBnByb3RvMw", [file_buf_validate_validate, file_google_api_field_behavior, file_google_protobuf_timestamp]);

/**
 * VersionContext selects which logical version of a resource should be
 * returned. At least one field must be set.
 *
 * @generated from message thru.common.v1.VersionContext
 */
export type VersionContext = Message<"thru.common.v1.VersionContext"> & {
  /**
   * Specifies the desired version semantics.
   *
   * @generated from oneof thru.common.v1.VersionContext.version
   */
  version: {
    /**
     * Request the latest version available at request time.
     *
     * @generated from field: thru.common.v1.CurrentVersion current = 1;
     */
    value: CurrentVersion;
    case: "current";
  } | {
    /**
     * Request the latest version, or historical on.
     *
     * @generated from field: thru.common.v1.CurrentOrHistoricalVersion currentOrHistorical = 2;
     */
    value: CurrentOrHistoricalVersion;
    case: "currentOrHistorical";
  } | {
    /**
     * Request the version for a specific slot number.
     *
     * @generated from field: uint64 slot = 3;
     */
    value: bigint;
    case: "slot";
  } | {
    /**
     * Request the version nearest to the provided block timestamp.
     *
     * @generated from field: google.protobuf.Timestamp timestamp = 4;
     */
    value: Timestamp;
    case: "timestamp";
  } | {
    /**
     * Request the account version written at an exact (slot, seq) point.
     * Relevant only for GetAccount and GetRawAccount requests.
     *
     * @generated from field: thru.common.v1.SlotSeq slot_seq = 5;
     */
    value: SlotSeq;
    case: "slotSeq";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message thru.common.v1.VersionContext.
 * Use `create(VersionContextSchema)` to create a new message.
 */
export const VersionContextSchema: GenMessage<VersionContext> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_consensus, 0);

/**
 * CurrentVersion is an empty marker message for VersionContext.current.
 *
 * @generated from message thru.common.v1.CurrentVersion
 */
export type CurrentVersion = Message<"thru.common.v1.CurrentVersion"> & {
};

/**
 * Describes the message thru.common.v1.CurrentVersion.
 * Use `create(CurrentVersionSchema)` to create a new message.
 */
export const CurrentVersionSchema: GenMessage<CurrentVersion> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_consensus, 1);

/**
 * CurrentOrHistoricalVersion is an empty marker message for VersionContext.current.
 *
 * @generated from message thru.common.v1.CurrentOrHistoricalVersion
 */
export type CurrentOrHistoricalVersion = Message<"thru.common.v1.CurrentOrHistoricalVersion"> & {
};

/**
 * Describes the message thru.common.v1.CurrentOrHistoricalVersion.
 * Use `create(CurrentOrHistoricalVersionSchema)` to create a new message.
 */
export const CurrentOrHistoricalVersionSchema: GenMessage<CurrentOrHistoricalVersion> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_consensus, 2);

/**
 * SlotSeq identifies an exact account version: the row written in `slot`
 * carrying per-account sequence number `seq`.  A bare seq is not a version
 * key -- it restarts across account incarnations -- so it is only
 * meaningful scoped to a slot.
 *
 * @generated from message thru.common.v1.SlotSeq
 */
export type SlotSeq = Message<"thru.common.v1.SlotSeq"> & {
  /**
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * @generated from field: uint64 seq = 2;
   */
  seq: bigint;
};

/**
 * Describes the message thru.common.v1.SlotSeq.
 * Use `create(SlotSeqSchema)` to create a new message.
 */
export const SlotSeqSchema: GenMessage<SlotSeq> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_consensus, 3);

/**
 * ConsensusStatus represents the minimum consensus level a resource has
 * achieved when returned by the service.
 *
 * @generated from enum thru.common.v1.ConsensusStatus
 */
export enum ConsensusStatus {
  /**
   * CONSENSUS_STATUS_UNSPECIFIED indicates the consensus status is unknown.
   *
   * @generated from enum value: CONSENSUS_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * CONSENSUS_STATUS_OBSERVED indicates the resource has been observed but
   * not yet confirmed in a finalized block.
   *
   * @generated from enum value: CONSENSUS_STATUS_OBSERVED = 1;
   */
  OBSERVED = 1,

  /**
   * CONSENSUS_STATUS_INCLUDED indicates the resource has been included in the
   * ledger but may not be finalized.
   *
   * @generated from enum value: CONSENSUS_STATUS_INCLUDED = 2;
   */
  INCLUDED = 2,

  /**
   * CONSENSUS_STATUS_FINALIZED indicates the resource is finalized for a slot.
   *
   * @generated from enum value: CONSENSUS_STATUS_FINALIZED = 3;
   */
  FINALIZED = 3,

  /**
   * CONSENSUS_STATUS_LOCALLY_EXECUTED indicates the local node executed the
   * resource but broader cluster finality may not have been achieved.
   *
   * @generated from enum value: CONSENSUS_STATUS_LOCALLY_EXECUTED = 4;
   */
  LOCALLY_EXECUTED = 4,

  /**
   * CONSENSUS_STATUS_CLUSTER_EXECUTED indicates the entire cluster has
   * executed and agreed on the resource.
   *
   * @generated from enum value: CONSENSUS_STATUS_CLUSTER_EXECUTED = 5;
   */
  CLUSTER_EXECUTED = 5,
}

/**
 * Describes the enum thru.common.v1.ConsensusStatus.
 */
export const ConsensusStatusSchema: GenEnum<ConsensusStatus> = /*@__PURE__*/
  enumDesc(file_thru_common_v1_consensus, 0);

